'use strict';

import { LoggerService, MessageService } from '@wephone-utils';
import { Injectable } from '@angular/core';
import * as sip from 'sipcore';
import { Observable, BehaviorSubject } from 'rxjs';
import { DateTime } from 'luxon';
import { ElectronService } from 'ngx-electron';

export class ActiveSubscription {
  callId: string;
  contact: string;
  userAgent: string;
  macAddr: string;
  from: string;
  to: string;
  connectionTime: string;
}

@Injectable()
export class GrandStreamProvisioningService {
  _pendingPhoneListSubject: BehaviorSubject<ActiveSubscription[]>;
  _pendingPhoneListObservable: Observable<ActiveSubscription[]>;
  subscriptionList: ActiveSubscription[] = [];

  constructor(
    private readonly messageService: MessageService,
    private readonly electron: ElectronService,
    private readonly loggerService: LoggerService,
  ) {
    this._pendingPhoneListSubject = new BehaviorSubject([]);
    this._pendingPhoneListObservable = this._pendingPhoneListSubject.asObservable();
  }

  pendingPhoneList(): Observable<ActiveSubscription[]> {
    return this._pendingPhoneListObservable;
  }

  startListening(): void {
    this.messageService.subscribe('grandstream:provision-subscribe', this.onSubscribeMessage);
  }

  onSubscribeMessage = (msg: string): void => {
    // this.loggerService.log('Raw data received is ', msg);
    try {
      const sipMsg: any = sip.parse(msg);
      const ruri = sip.parseUri(sipMsg.uri);
      const macAddr = ruri.headers.substr(1).split('@')[0];
      // this.loggerService.log('Sip Msg is ', sipMsg, ruri);

      const sub = new ActiveSubscription();
      sub.callId = sipMsg.headers['call-id'];
      sub.contact = sipMsg.headers['contact'].replace('<', '').replace('>', '');
      sub.userAgent = sipMsg.headers['user-agent'];
      sub.from = sipMsg.headers['from'];
      sub.to = sipMsg.headers['to'];
      sub.macAddr = macAddr;
      sub.connectionTime = DateTime.local().toLocaleString(DateTime.DATETIME_FULL);
      let foundIndex = -1;
      for (let i = 0; i < this.subscriptionList.length; i++) {
        if (this.subscriptionList[i].macAddr === sub.macAddr) {
          foundIndex = i;
          break;
        }
      }
      if (foundIndex >= 0) {
        this.subscriptionList.splice(foundIndex, 1);
      }
      this.subscriptionList.push(sub);

      this._pendingPhoneListSubject.next(this.subscriptionList);
      this.sendOKForSubscription(sipMsg);
    } catch (e) {
      this.loggerService.error('Unable to parse SUBSCRIBE message', e);
    }
  }

  sendOKForSubscription(subMsg: any) {
    let okMsg = `SIP/2.0 200 OK\r
Via: SIP/2.0/UDP 127.0.0.1:5060;branch=z9hG4bKtrxftxslfcy3aagf3c9s7;rport=5060\r
From: ${subMsg.headers['from']}\r
To: ${subMsg.headers['to']};tag=12345\r
Call-ID: ${subMsg.headers['call-id']}\r
CSeq: ${subMsg.headers['cseq']}\r
Expires: 3600\r
Contact: ${subMsg.headers['contact']}\r
Server: Graam Phone App\r
Content-Length: 0\r
\r
`;

    const contactHeader = subMsg.headers['contact'].replace('<', '').replace('>', '');
    const c = sip.parseUri(contactHeader);
    // this.loggerService.log(`Sending OK message to ${c.hostname}:${c.password}`, okMsg);
    this.electron.ipcRenderer.send('grandstream:send-sip-message', { host: c.hostname, port: c.password, message: okMsg });
  }

  sendPhoneConfiguration(subscription: ActiveSubscription, url: string) {
    let notifyMsg = `NOTIFY ${subscription.contact} SIP/2.0\r
Via: SIP/2.0/UDP 127.0.0.1:6060;branch=z9hG4dkf357345334\r
From: <sip:192.168.90.100:5060>;tag=23843435\r
To: <${subscription.contact}>\r
Call-ID: 32248u28424234@127.0.0.1\r
CSeq: 1 NOTIFY\r
Contact: <sip:127.0.0.1:6060>\r
Content-Type: application/url\r
Max-Forwards: 10\r
User-Agent: Graam Phone App\r
Event: ua-profile\r
Content-Length: ${url.length}\r
\r
${url}`;
    const contactHeader = sip.parseUri(subscription.contact);
    this.electron.ipcRenderer.send('grandstream:send-sip-message', { host: contactHeader.hostname, port: contactHeader.password, message: notifyMsg });
  }
}
